import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link,useNavigate } from "react-router-dom";
import swal from 'sweetalert';

const Dashboard = () =>{
    let navigate = useNavigate();

    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
        if (user) {
            
        } else {
            swal({
                title: "Buddy,login first",
                text: "Please login",
                icon: "warning",
                button: "Okay",
              });
            navigate(`/`);
        }
      });

      const handleSignOut = ()=>{
        signOut(auth).then(() => {
            swal({
                title: "Sign Out Succcesfully",
                icon: "success",
                button: "Okay",
              });
              navigate(`/`);
        }).catch((error) => {
  
        });
      }
      

    return(
        <>
            
            <div className="container ">
                <div className="col-sm text-center">
                    <i className="fa fa-home h3" aria-hidden="true"> Admin Panel</i>
                    <p className="h3"></p>
                    <button onClick={handleSignOut} className="btn admitbtn">Sign Out</button>
                </div>

                <div className="row gy-5">
                    <div className="col-sm">    
                        <div className="card  text-center">
                            <div className="card-body admin-card">
                                <p className="h4"> <i className="fa fa-comment" aria-hidden="true"></i> Add PopUp</p>
                                <Link to="/dashboard/add-popup" className="btn btn-secondary">Go</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="card text-center">
                            <div className="card-body admin-card">
                                <p className="h4"> <i className="fa fa-user" aria-hidden="true"></i> Add Team Profile</p>
                                <Link to="/dashboard/addprofile" className="btn btn-secondary">Go</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <br/><hr/><br/>
                <div className="row gy-5">
                    <div className="col-sm">    
                        <div className="card text-center">
                            <div className="card-body admin-card ">
                                <p className="h4"> <i className="fa fa-database" aria-hidden="true"></i> Data</p>
                                <Link to="/dashboard/" className="btn btn-secondary">Go</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="card text-center">
                            <div className="card-body admin-card">
                                <p className="h4"> <i className="fa fa-user" aria-hidden="true"></i> Add Event images</p>
                                <Link to="/dashboard/add-snapshot" className="btn btn-secondary">Go</Link>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    )

}
export default Dashboard;